/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-useless-constructor */
import { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { API_URL } from '../../../../utils/constants';
import GridWrapper from '~/src/components/common/GridWrapper';
import createIcon from '../../../../static/img/createIcon.svg';

export default function SuppliersList(): JSX.Element {
  const history = useHistory();
  const stateRef = useRef(null);
  const url = `${API_URL}/contractors/suppliers/get`;
  const StatefullGrid = withState(Grid, url);

  const countryCell = (p) => {
    return <td>{p?.dataItem?.contractor?.country?.name}</td>;
  };

  const productNameCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/suppliers/edit/${dataItem.id}`}>{dataItem?.name}</Link>
      </td>
    );
  };

  return (
    <WhitePad>
      <TitleComponent
        title="Suppliers"
        titleRight="Create"
        onRightHandler={(): void => history.push('/suppliers/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="name" title="Supplier Name" cell={(row) => productNameCell(row, stateRef)} />
          <GridColumn field="countryId" title="Country" cell={countryCell} />
          <GridColumn field="nonReeferTransportCostPerPallet" title="Non-Reefer Transport Cost" />
          <GridColumn field="reeferTransportCostPerPallet" title="Reefer Transport Cost" />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
